/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://roq7bbtlsvfuzjvt43dhtssese.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-plsujs6jivhtnh2bukckcwcxui",
    "aws_cognito_identity_pool_id": "us-east-1:3bd1b8ce-b392-4158-8166-9338cd036480",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_klT7e969v",
    "aws_user_pools_web_client_id": "2oj66ocedoli076mhlmtuqlhqq",
    "oauth": {
        "domain": "auth.cimaiot.com.auth.us-east-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "phone",
            "profile"
        ],
        "redirectSignIn": "https://app.cimaiot.com/",
        "redirectSignOut": "https://app.cimaiot.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "cimaiot-storage-64bfa630133507-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
